import { render } from "./ProdutoResumido.vue?vue&type=template&id=6c5c884e&scoped=true"
import script from "./ProdutoResumido.vue?vue&type=script&lang=js"
export * from "./ProdutoResumido.vue?vue&type=script&lang=js"

import "./ProdutoResumido.vue?vue&type=style&index=0&id=6c5c884e&lang=scss"
import "./ProdutoResumido.vue?vue&type=style&index=1&id=6c5c884e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5c884e"]])

export default __exports__